import React, { Component } from "react";
import PedidoDevolucaoMaterialNovo from "../PedidoDevolucaoMaterialNovo";

export default class DevolucaoMaterialNovo extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return <PedidoDevolucaoMaterialNovo tipoPedido={1} {...this.props} />;
  }
}
